import Table from './Table';
export default Table;


//////////////////
// WEBPACK FOOTER
// /Users/ddcat/project/ant-design-pro-site/ant-design-pro-site/scaffold/node_modules/antd/es/table/index.js
// module id = 693
// module chunks = 0